import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import HistoryIcon from '@mui/icons-material/History';
import StarIcon from '@mui/icons-material/Star';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import FolderIcon from '@mui/icons-material/Folder';
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import GroupIcon from '@mui/icons-material/Group';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PublicIcon from '@mui/icons-material/Public';

export interface SidebarItem {
  key: string;
  label: string;
  icon: React.ReactNode;
  children?: SidebarItem[];
  disabled?: boolean;
  route?: string;
}

export const getSidebarConfig = (userType: 'guest' | 'user'): SidebarItem[] => [
  {
    key: 'home',
    label: '簡播',
    icon: (
      <span style={{ position: 'relative', display: 'inline-block' }}>
        <PlayArrowIcon
          sx={{
            color: '#fff',
            fontSize: 46,
            position: 'absolute',
            left: 0,
            top: 0,
            zIndex: 1,
          }}
        />
        <PlayArrowIcon
          sx={{
            color: '#d32f2f',
            fontSize: 40,
            position: 'relative',
            zIndex: 2,
          }}
        />
      </span>
    ),
    children: []
  },
  {
    key: 'personalCenter',
    label: '個人',
    icon: <PersonIcon sx={{ fontSize: 40, color: userType === 'guest' ? '#ccc' : '#2196F3' }} />,
    disabled: userType === 'guest',
    children: userType === 'guest' ? [] : [
      { 
        key: 'personalHistory', 
        label: '｜瀏覽記錄', 
        icon: <HistoryIcon sx={{ fontSize: 18, color: '#1976d2' }} />, 
        disabled: false,
        route: '/manage?section=personalHistory'
      },
      { 
        key: 'myVideos', 
        label: '｜我的創作', 
        icon: <VideoLibraryIcon sx={{ fontSize: 18, color: '#4CAF50' }} />, 
        disabled: false,
        route: '/manage?section=myVideos'
      },
      { 
        key: 'myPersonalFavorite', 
        label: '｜我的收藏', 
        icon: <StarIcon sx={{ fontSize: 18, color: '#FFD700' }} />, 
        disabled: false,
        route: '/manage?section=myPersonalFavorite'
      }
    ]
  },
  {
    key: 'community',
    label: '社群',
    icon: <GroupIcon sx={{ fontSize: 40, color: '#FF9800' }} />,
    children: [
      { 
        key: 'communityPublic', 
        label: '｜社群公開', 
        icon: <PublicIcon sx={{ fontSize: 18, color: '#00BCD4' }} />, 
        disabled: false,
        route: '/manage?section=communityPublic'
      },
      { 
        key: 'teamPoint', 
        label: '｜群組影片', 
        icon: <SportsScoreIcon sx={{ fontSize: 18, color: '#9C27B0' }} />, 
        disabled: userType === 'guest',
        route: '/manage?section=teamPoint'
      },
      { 
        key: 'expertKnowledge', 
        label: '｜專家筆記', 
        icon: <TrendingUpIcon sx={{ fontSize: 18, color: '#F44336' }} />, 
        disabled: false,
        route: '/manage?section=expertKnowledge'
      },
      { 
        key: 'follow', 
        label: '｜追蹤收藏', 
        icon: <StarIcon sx={{ fontSize: 18, color: '#FFD700' }} />, 
        disabled: userType === 'guest',
        route: '/manage?section=follow'
      }
    ]
  },
  {
    key: 'fileManagement',
    label: '專案',
    icon: <FolderIcon sx={{ fontSize: 40, color: '#4CAF50' }} />,
    children: [
      { 
        key: 'fileUpload', 
        label: '｜檔案上傳', 
        icon: <CloudUploadIcon sx={{ fontSize: 18, color: '#2196F3' }} />, 
        disabled: false,
        route: '/manage?section=fileUpload'
      },
      { 
        key: 'localDirectory', 
        label: '｜本機目錄', 
        icon: <FolderIcon sx={{ fontSize: 18, color: '#FF9800' }} />, 
        disabled: false,
        route: '/manage?section=localDirectory'
      },
      { 
        key: 'cloudDirectory', 
        label: '｜雲端目錄', 
        icon: <FolderIcon sx={{ fontSize: 18, color: '#9C27B0' }} />, 
        disabled: false,
        route: '/manage?section=cloudDirectory'
      },
      { 
        key: 'projectManagement', 
        label: '｜專案管理', 
        icon: <PlaylistPlayIcon sx={{ fontSize: 18, color: '#F44336' }} />, 
        disabled: false,
        route: '/manage?section=projectManagement'
      }
    ]
  },
  {
    key: 'deliveryManagement',
    label: '交片',
    icon: <CloudUploadIcon sx={{ fontSize: 40, color: '#FF0000' }} />,
    children: [
      { 
        key: 'clientArea', 
        label: '｜品牌專區', 
        icon: <PublicIcon sx={{ fontSize: 18, color: '#00BCD4' }} />, 
        disabled: false,
        route: '/manage?section=clientArea'
      },
      { 
        key: 'clientManagement', 
        label: '｜品牌管理', 
        icon: <GroupIcon sx={{ fontSize: 18, color: '#9C27B0' }} />, 
        disabled: false,
        route: '/manage?section=clientManagement'
      }
    ]
  },
  {
    key: 'settings',
    label: '個人設定',
    icon: <SettingsIcon sx={{ fontSize: 40, color: '#FF0000' }} />,
    children: [],
    route: '/manage?section=settings'
  }
];
